import { createAsyncThunk } from '@reduxjs/toolkit';
import { client } from '@global/Api';
import {
  Entitlement,
  GET_ENTITLEMENTS,
  GET_ENTITLEMENTS_RESPONSE,
  GET_ENTITLEMENTS_VARIABLES,
} from '@src/global/requests/entitlements';
import { getCookieValue } from '@src/global/utils/cookie';
import { ECOM_COOKIE_KEY } from '@src/global/App/constants/constants';

export const getEntitlements = createAsyncThunk<
  Entitlement[],
  void,
  { rejectValue: string }
>('entitlements/getEntitlements', async (_, { rejectWithValue }) => {
  const ecomToken = getCookieValue(ECOM_COOKIE_KEY);

  if (!ecomToken) {
    return rejectWithValue('SERVER_ERROR: Ecom token not found in cookies');
  }

  try {
    const {
      data: {
        wGetEntitlements: { result },
      },
    } = await client.query<
      GET_ENTITLEMENTS_RESPONSE,
      GET_ENTITLEMENTS_VARIABLES
    >({
      query: GET_ENTITLEMENTS,
      variables: { ecomToken },
      fetchPolicy: 'network-only',
    });

    if (result.status === 'ERROR') {
      return rejectWithValue(
        result.errors.map((error) => error.message).join('\n') ||
          'SERVER_ERROR: ViaxUserNotFoundError'
      );
    }

    if (!Array.isArray(result.entitlements)) {
      return rejectWithValue(
        result.entitlements.message || 'SERVER_ERROR: EntitlementsError'
      );
    }

    return result.entitlements;
  } catch (e) {
    return rejectWithValue(`SERVER_ERROR: getEntitlements failed: ${e}`);
  }
});
